import { Injectable } from "@angular/core";
import * as moment from "moment";
// import * as AWS from 'aws-sdk';
import * as piexif from '../../../assets/js/piexifjs.js';

declare let LUDYSTORAGE_AWSS3_ACCESSKEY: any;
declare let LUDYSTORAGE_AWSS3_SECRETKEY: any;
declare let LUDYSTORAGE_AWSS3_BUCKET: any;
declare let LUDYSTORAGE_AWSS3_PREFIX: any;
declare let jic: any,AWS:any;

@Injectable()
export class Aws {

    bucket: any;

    constructor() {
        AWS.config.update({
            accessKeyId: LUDYSTORAGE_AWSS3_ACCESSKEY,
            secretAccessKey: LUDYSTORAGE_AWSS3_SECRETKEY,
        });
        this.bucket = new AWS.S3({ params: { Bucket: LUDYSTORAGE_AWSS3_BUCKET } });
    }


    /**
     * Permite subir un archivo a AWS
     * @param {File} fileChooser
     * @returns {undefined}
     */
    uploadFile(fileChooser, callbackSuccess, callbackError, contentDisposition?, includeSignature?) {

        let file: any;
        let disposition = "inline";
        if (fileChooser != null && fileChooser.files != null) {
            file = fileChooser.files[0];
        } else {
            file = fileChooser;
        }

        if (file) {
            if (contentDisposition != null) {
                disposition = contentDisposition;
            }

            this.fileCompressor(file).then((file) => {
                var fileKey = moment(new Date()).format("YYMMDDHHmmss") + "-" + this.randomString();

                var params = {
                    Key: LUDYSTORAGE_AWSS3_PREFIX + fileKey,
                    ContentType: (file as any).type,
                    Body: file,
                    ACL: 'public-read',
                    ContentDisposition: disposition + "; filename=" + this.removeAccents((file as any).name) + ";"
                };

                if (includeSignature) {
                    params["Metadata"] = {
                        "ludystorage-signature": "1"
                    };
                }

                this.bucket.upload(params, function (err, data) {
                    if (!err) {
                        data["fileKey"] = fileKey;
                        callbackSuccess(data);
                    } else {
                        callbackError(err);
                    }
                });
            });


        }
    }

    /**
     * comprime imagenes
     * @param {type} file
     * @returns {Promise}
     */
    fileCompressor(file) {

        return new Promise((resolve, reject) => {
            if (file != null && file.type.indexOf("image") >= 0) {
                var img = document.createElement("img");

                var reader = new FileReader();

                reader.onload = (e) => {
                    img.src = (e.target as any).result;

                    let quality = 30,
                        output_format = 'jpg';

                    let base64Imagecompress = jic.compress(img, quality, output_format).src;
                    let exifbytes = this.resolveMetadata(img.src, file.type);

                    if (exifbytes) {
                        try {
                            base64Imagecompress = piexif.insert(exifbytes, base64Imagecompress);
                        } catch (e) {
                            console.log(e);
                        }

                    }

                    let compressFile = this.base64ToFile(base64Imagecompress, file.name, file.fileKey);

                    if (compressFile) {
                        resolve(compressFile);
                    } else {
                        resolve(file);
                    }

                };

                reader.readAsDataURL(file);
            } else {
                resolve(file);
            }
        });
    }

    /**
     * metodo que entrega los metadatos utilizados
     * para ser enviados a amazon y ludystorage.
     * @returns {undefined}
     */
    resolveMetadata(base64Image, imageType) {
        try {
            if (base64Image && (imageType == "image/jpeg" || imageType == "image/jpg")) {

                var exif = {};
                var zeroth = {};
                var gps = {};
                var exifObj = piexif.load(base64Image);
                for (var ifd in exifObj) {
                    for (var tag in exifObj[ifd]) {

                        if (ifd != "0th" && ifd != "Exif" && ifd != "GPS") break;
                        var key = (piexif.TAGS && piexif.TAGS[ifd] && piexif.TAGS[ifd][tag] && piexif.TAGS[ifd][tag]["name"]) ? piexif.TAGS[ifd][tag]["name"] : null;
                        var value = (exifObj[ifd] && exifObj[ifd][tag]) ? exifObj[ifd][tag] : null;
                        if (ifd == "0th" && value && key) {
                            var zerothId = (piexif.ImageIFD[key]) ? piexif.ImageIFD[key] : null;
                            if (zerothId) zeroth[zerothId] = value;
                        }

                        if (ifd == "Exif" && value && key) {
                            var exifId = (piexif.ExifIFD[key]) ? piexif.ExifIFD[key] : null;
                            if (exifId) exif[exifId] = value;
                        }

                        if (ifd == "GPS" && value && key) {
                            var gpsId = (piexif.GPSIFD[key]) ? piexif.GPSIFD[key] : null;
                            if (gpsId) gps[exifId] = value;
                        }

                    }
                }

                var exifObj = { "0th": zeroth, "Exif": exif, "GPS": gps };
                var exifbytes = piexif.dump(exifObj);
                return exifbytes;
            }
        } catch (e) {
            console.log(e);
        }

    }

    randomString() {
        var result = '';
        var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for (var i = 32; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    }

    removeAccents(filename) {

        var text = filename.toLowerCase(); // a minusculas
        text = text.replace(/[áàäâå]/, 'a');
        text = text.replace(/[éèëê]/, 'e');
        text = text.replace(/[íìïî]/, 'i');
        text = text.replace(/[óòöô]/, 'o');
        text = text.replace(/[úùüû]/, 'u');
        text = text.replace(/[ýÿ]/, 'y');
        // text = text.replace(/[^a-zA-Z0-9-]/, '');
        return text;
    }

    base64ToFile(base64Image, fileName, fileKey) {
        try {
            var arr = base64Image.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            let options = { type: mime, fileKey: fileKey };
            var file = new File([u8arr], fileName, options);
            file["fileKey"] = fileKey;
            return file;
        } catch (e) {
            return null;
        }

    }


}

